// extracted by mini-css-extract-plugin
export var gif = "_jx-0";